import React from 'react'

const AIGeneratedNewIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none">
                <path
                    d="M30.4 28.25L34.15 30.125L30.4 32L28.525 35.75L26.65 32L22.9 30.125L26.65 28.25L28.525 24.5L30.4 28.25ZM19.275 16.125L27.025 20L19.275 23.875L15.4 31.625L11.5162 23.875L3.77502 20L11.5162 16.125L15.4 8.375L19.275 16.125ZM30.4 8L34.15 9.875L30.4 11.75L28.525 15.5L26.65 11.75L22.9 9.875L26.65 8L28.525 4.25L30.4 8Z"
                    fill="#455D82"
                />
            </svg>
        </>
    )
}

export default AIGeneratedNewIcon
